import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledDiv = styled.div`
  max-width: 100%;
`;

export const OtherContent = props => {
  return <StyledDiv dangerouslySetInnerHTML={{ __html: props.content }} />;
};

OtherContent.propTypes = {
  content: PropTypes.string,
};

OtherContent.defaultProps = {
  content: null,
};

export default OtherContent;



// WEBPACK FOOTER //
// ./src/components/OtherContent/index.js